/**
 * Grades scene
 *
 * @author Carlos Silva <csilva@ubiwhere.com>
 *
 */
 
import React, { useEffect } from 'react'
import styled from 'styled-components'

import { useDispatch, /*useSelector*/ } from 'react-redux'

import { actions } from 'store/rootSlices'

//import config from 'config'

const Grades = ({ t, i18n }) => {

  //const { } = useSelector(state => state.Grades)

  const { onMount, onUnmount} = actions.Grades
  //const { api_t } = actions.App

  const dispatch = useDispatch()

  useEffect(() => {

    dispatch(onMount())
    return () => {
      dispatch(onUnmount())
    }
  }, [dispatch, onMount, onUnmount]);

  return (
    <Wrapper>
      Grades
    </Wrapper>
  )
}

export default Grades

const Wrapper = styled.div``